import React from 'react';
import Modal from '..//Modal/Modal';
import { useAppContext } from '../../Services/AppContext';
import MedicalReportDetailWrapper from './MedicalReportDetailWrapper';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import { getIsLatam } from '../../Modules/Region/Servises/region.service';

interface MedicalReportDetailModalProps {
	patientId: string;
	workplaceId: string;
	loggedUserId?: string;
	caseId?: string;
	opened: boolean;
	onClose: () => void;
	onMedicalReportCreate?: () => void;
	defaultData?: any;
	attachToDiscourse?: boolean;
	createDekurz?: boolean;
}

const MedicalReportDetailModal: React.FC<MedicalReportDetailModalProps> = ({
	opened,
	onClose,
	patientId,
	workplaceId,
	caseId,
	defaultData,
	loggedUserId,
	onMedicalReportCreate,
	attachToDiscourse = false,
	createDekurz,
}) => {
	const loggedUser = loggedUserId || useAppContext().loggedUserId;
	const { isCase } = useTreatmentContext();
	const isLatam = getIsLatam();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
			<Modal.Header
				title={
					isLatam
						? 'base.shared.medicalExamination'
						: 'base.shared.medicalReport'
				}
			/>
			<Modal.Content contentScroll={true}>
				<MedicalReportDetailWrapper
					patientId={patientId}
					onSubmit={onClose}
					workplaceId={workplaceId}
					defaultData={defaultData}
					loggedUserId={loggedUser}
					caseId={caseId}
					onMedicalReportCreate={onMedicalReportCreate}
					attachToDiscourse={attachToDiscourse}
					createDekurz={createDekurz}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default MedicalReportDetailModal;
